import * as React from "react";
import { Component } from "react";
import ModalPanel from "Panels/ModalPanel";
import { Device } from "@inductosense/typescript-fetch";
import UiSettings from "../Model/UiSettings";
import DeviceDataExtractionLogsPanel from "./DeviceDataExtractionLogsPanel";

interface DeviceDataExtractionLogsModalPanelProps {
    shouldBeShown: boolean;
    onClose(): void;
    device: Device;
    uiSettings: UiSettings;
}

export default class DeviceDataExtractionLogsModalPanel extends Component<DeviceDataExtractionLogsModalPanelProps> {
    constructor(props: DeviceDataExtractionLogsModalPanelProps) {
        super(props);

        this.state = {};
    }

    render() {
        const { onClose, shouldBeShown, device, uiSettings } = this.props;

        return (
            <ModalPanel
                title="Data Extraction Logs"
                shouldBeShown={shouldBeShown}
                onClose={() => onClose()}
                content={<DeviceDataExtractionLogsPanel device={device} uiSettings={uiSettings} />}
            />
        );
    }
}
